<template>

  <div class="mx-sm-1 mt-9">
    <div class="page-header">
      <h1 class="page-title fw-bold">Generation PPM</h1>
      <div>
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'dashboard' }"><a>Tableau de
              bord</a></router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            <router-link
                :to="{ name: 'generationPpm' }">Generation PPM</router-link>
          </li>
        </ol>
      </div>
    </div>

    <div class="modal fade" v-if="activite" id="modal-detail-activity" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-xl "  role="document">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h6 class="modal-title fw-bold" style="font-size: 16px;">Detail PTA</h6><button aria-label="Close" class="btn-close text-white"
                                                                                                                             data-bs-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
          </div>
          <div class="modal-body">
            <ul class="row p-3">
              <li class="col-lg-12 mb-2">
                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="form-label">Année <span class="text-danger">*</span></label>
                      <multi-select disabled deselect-label="Sélectionné" select-label=""
                                    :options="exercices" @select="loadActionsGrouped"
                                    placeholder="Sélectionné une année " label="annee"
                                    track-by="annee" :searchable="true"
                                    :custom-label="o => o.annee"
                                    v-model="payload.exercice">
                        <template slot="singleLabel" slot-scope="{ option }">
                          <strong> {{ option.annee }}</strong>
                        </template>
                        <span slot="noOptions">
                                                    <strong>Liste Vide</strong>
                                                </span>
                        <span slot="noResult">
                                                    <strong>Aucun Résultat</strong>
                                                </span>
                      </multi-select>

                    </div>
                  </div>


                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="form-label">ID PTA Interne <span class="text-danger">*</span></label>
                      <input class="form-control mb-4" disabled v-model="activite.idPtaAsin" readonly="" type="text">

                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="form-label">Activité</label>
                      <input class="form-control mb-4" disabled v-model="activite.description" readonly="" type="text">

                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="form-label">Status Arbitrage  <span class="text-danger">*</span></label>
                      <input class="form-control mb-4" disabled v-model="activite.statut" readonly="" type="text">

                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group m-0">
                      <label class="form-label">BESOINS</label>
                      <hr class="mt-2" style="border-top: 2px solid #ccc;">
                      <div class="row ">
                        <div class="col-6">
                          <label class="form-label">Total AE</label>
                          <AmountInput class="form-control border-dark " readonly   v-model="activite.besoinAeTotTtc"  />
                        </div>
                        <div class="col-6">
                          <label class="form-label">Total CP</label>
                          <AmountInput class="form-control border-dark " readonly    v-model="activite.besoinCpTotTtc"  />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group m-0 text-center">
                      <label class="form-label">REPORTS</label>
                      <hr class="mt-2" style="border-top: 2px solid #ccc;">
                      <div class="row justify-content-center">
                        <div class="col-6">
                          <label class="form-label">Total :</label>
                          <AmountInput class="form-control border-dark " readonly   v-model="activite.reportMobiliseTot"  />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group m-0">
                      <label class="form-label">ALLOUEES</label>
                      <hr class="mt-2" style="border-top: 2px solid #ccc;">
                      <div class="row ">
                        <div class="col-6">
                          <label class="form-label">Total AE</label>
                          <AmountInput class="form-control border-dark " readonly   v-model="activite.alloueAeTotTtc"  />
                        </div>
                        <div class="col-6">
                          <label class="form-label">Total CP</label>
                          <AmountInput class="form-control border-dark " readonly   v-model="activite.alloueCpTotTtc"  />
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </li>

              <li class="col-lg-12 mb-2">
                <div class="card">
                  <div class="card-header">
                    <h3 class="card-title fw-bold">Informations du marche</h3>
                  </div>
                  <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group m-0">
                                <div class="row ">
                                    <div class="col-6">
                                        <label class="form-label">Methodologie souhaite</label>
                                        <multi-select v-model="activite.idMethodMarche" disabled deselect-label="Sélectionné" select-label="" :options="methodologies"
                                                        placeholder="Sélectionné le type" label="libelle" track-by="idMethodMarche" :searchable="true">
                                            <span slot="noOptions">
                                                <strong>Liste Vide</strong>
                                            </span>
                                            <span slot="noResult">
                                                <strong>Aucun Résultat</strong>
                                            </span>
                                        </multi-select>
                                    </div>
                                    <div class="col-6">
                                        <label class="form-label">Organe de controle</label>
                                        <select v-model="activite.organeControle" disabled class="form-control">
                                            <option disabled value="">Sélectionnez</option>
                                            <option value="AMI">AMI</option>
                                            <option value="DP">DP</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group m-0 text-center">
                                <div class="row">
                                    <div class="col-6">
                                        <label class="form-label">Durée estime :</label>
                                        <input type="number" class="form-control" disabled v-model="activite.dureeEstimMarche">
                                    </div>
                                    <div class="col-6">
                                        <label class="form-label">Date Prevue lancement :</label>
                                        <input type="date" class="form-control" disabled v-model="activite.datePrevuLancement">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group m-0">
                            <div class="row ">
                                <div class="col-6">
                                    <label class="form-label">Date Prevue lancement au plus tard</label>
                                    <input type="date" class="form-control" disabled v-model="activite.dateLanceAuplustard">
                                </div>
                                <div class="col-6">
                                    <label class="form-label">Date prevue contrat</label>
                                    <input type="date" class="form-control" disabled v-model="activite.datePrevueContrat">
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group m-0">
                                <div class="row ">
                                    <div class="col-6">
                                        <label class="form-label">Eligible Marche</label>
                                        <select v-model="activite.eligibleMarche" disabled class="form-control">
                                            <option disabled value="">Sélectionnez</option>
                                            <option value="Oui">Oui</option>
                                            <option value="Non">Non</option>
                                        </select>
                                    </div>
                                    <div class="col-6">
                                        <label class="form-label">Contrat Cadre</label>
                                        <select v-model="activite.contratCadre" disabled class="form-control">
                                            <option disabled value="">Sélectionnez</option>
                                            <option value="Oui">Oui</option>
                                            <option value="Non">Non</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group m-0 text-center">
                                <div class="row">
                                    <div class="col-6">
                                        <label class="form-label">Typologie Investissement :</label>
                                        <multi-select v-model="activite.typologie" disabled deselect-label="Sélectionné" select-label="" :options="typologies"
                                                        placeholder="Sélectionné le type" label="typologie" track-by="typologie" :searchable="true">
                                            <span slot="noOptions">
                                                <strong>Liste Vide</strong>
                                            </span>
                                            <span slot="noResult">
                                                <strong>Aucun Résultat</strong>
                                            </span>
                                        </multi-select>
                                    </div>
                                    <div class="col-6">
                                        <label class="form-label">Mission Terrain PMO Hors budget :</label>
                                        <select v-model="activite.missionTerrainPmo" disabled class="form-control">
                                            <option disabled value="">Sélectionnez</option>
                                            <option value="Oui">Oui</option>
                                            <option value="Non">Non</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group m-0">
                            <div class="row ">
                                <div class="col-6">
                                    <label class="form-label">Tache de communication / Mission</label>
                                    <input type="text" class="form-control" disabled v-model="activite.tacheCom">
                                </div>
                                <div class="col-6">
                                    <label class="form-label">Poids</label>
                                    <input type="text" class="form-control" disabled v-model="activite.poids">
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group m-0">
                                <div class="row ">
                                    <div class="col-6">
                                        <label class="form-label">Source de financement</label>
                                        <multi-select v-model="activite.sourceFinancement" disabled deselect-label="Sélectionné" select-label="" :options="sourcesFinancement"
                                                        placeholder="Sélectionné la source" label="sourceFinancement" track-by="sourceFinancement" :searchable="true">
                                            <span slot="noOptions">
                                                <strong>Liste Vide</strong>
                                            </span>
                                            <span slot="noResult">
                                                <strong>Aucun Résultat</strong>
                                            </span>
                                        </multi-select>
                                    </div>
                                    <div class="col-6">
                                        <label class="form-label">Beneficiaire</label>
                                        <input type="text" class="form-control" disabled v-model="activite.beneficiaire">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group m-0 text-center">
                                <div class="row">
                                    <div class="col-6">
                                        <label class="form-label">Categorie :</label>
                                        <select v-model="activite.categorie" disabled class="form-control">
                                            <option disabled value="">Sélectionner la categorie</option>
                                            <option value="Nouveau">Nouveau</option>
                                            <option value="Reconduite">Reconduite</option>
                                        </select>
                                    </div>
                                    <div class="col-6">
                                        <label class="form-label">Recurrent :</label>
                                        <select v-model="activite.recurrent" disabled class="form-control">
                                            <option disabled value="">Sélectionnez</option>
                                            <option value="Oui">Oui</option>
                                            <option value="Non">Non</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="modal-footer">
            <button class="btn btn-gray" data-bs-dismiss="modal">Fermer</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="ppm-start" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-xl "  role="document">
        <div class="modal-content">
          <div v-for="(alm, index) in allMarches">
            <div class="modal-header bg-primary text-white">
            <h6 class="modal-title fw-bold" style="font-size: 16px;">Generation PPM {{ index + 1 }} </h6><button v-if="index === 0" aria-label="Close" class="btn-close text-white"
                                                                                                                             data-bs-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
          </div>
          <div class="modal-body">
            <ul class="row p-3">
              <li class="col-lg-12 mb-2">
                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="form-label">Année <span class="text-danger">*</span></label>
                      <multi-select disabled deselect-label="Sélectionné" select-label=""
                                    :options="exercices" @select="loadActionsGrouped"
                                    placeholder="Sélectionné une année " label="annee"
                                    track-by="annee" :searchable="true"
                                    :custom-label="o => o.annee"
                                    v-model="payload.exercice">
                        <template slot="singleLabel" slot-scope="{ option }">
                          <strong> {{ option.annee }}</strong>
                        </template>
                        <span slot="noOptions">
                                                    <strong>Liste Vide</strong>
                                                </span>
                        <span slot="noResult">
                                                    <strong>Aucun Résultat</strong>
                                                </span>
                      </multi-select>

                    </div>
                  </div>


                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="form-label">ID PTA Interne <span class="text-danger">*</span></label>
                      <input class="form-control mb-4" disabled v-model="alm.tempActivite.idPtaAsin" readonly="" type="text">

                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="form-label">Activité</label>
                      <input class="form-control mb-4" disabled v-model="alm.tempActivite.description" readonly="" type="text">

                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="form-label">Status Arbitrage  <span class="text-danger">*</span></label>
                      <input class="form-control mb-4" disabled v-model="alm.tempActivite.statut" readonly="" type="text">

                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group m-0">
                      <label class="form-label">BESOINS</label>
                      <hr class="mt-2" style="border-top: 2px solid #ccc;">
                      <div class="row ">
                        <div class="col-6">
                          <label class="form-label">Total AE</label>
                          <AmountInput class="form-control border-dark " readonly   v-model="alm.tempActivite.besoinAeTotTtc"  />
                        </div>
                        <div class="col-6">
                          <label class="form-label">Total CP</label>
                          <AmountInput class="form-control border-dark " readonly    v-model="alm.tempActivite.besoinCpTotTtc"  />
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="col-md-4">
                    <div class="form-group m-0 text-center">
                      <label class="form-label">REPORTS</label>
                      <hr class="mt-2" style="border-top: 2px solid #ccc;">
                      <div class="row justify-content-center">
                        <div class="col-6">
                          <label class="form-label">Total :</label>
                          <AmountInput class="form-control border-dark " readonly   v-model="alm.tempActivite.reportMobiliseTot"  />
                        </div>
                      </div>
                    </div>
                  </div> -->
                  <div class="col-md-6">
                    <div class="form-group m-0">
                      <label class="form-label">DONNEES</label>
                      <hr class="mt-2" style="border-top: 2px solid #ccc;">
                      <div class="row ">
                        <div class="col-6">
                          <label class="form-label">Montant PPM HT</label>
                          <AmountInput class="form-control border-dark " readonly   v-model="alm.montantPpmHt"  />
                        </div>
                        <div class="col-6">
                          <label class="form-label">Intitule</label>
                          <input type="text" class="form-control" v-model="alm.intitule">
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </li>

              <li class="col-lg-12 mb-2">
                <div class="card">
                  <div class="card-header">
                    <h3 class="card-title fw-bold">Informations du Plan de passation</h3>
                  </div>
                  <div class="card-body">
                    <div class="row">
                        <div class="col-md">
                            <div class="form-group m-0">
                                <label class="form-label">Date reception TDRS :</label>
                                <input type="date" class="form-control" v-model="alm.dateRecepTdrs">
                            </div>
                        </div>
                        <div class="col-md">
                            <div class="form-group m-0">
                                <label class="form-label">Date reception dossier controle :</label>
                                <input type="date" class="form-control" v-model="alm.dateDaoRecepDossierCtl">
                            </div>
                        </div>
                        <div class="col-md">
                            <div class="form-group m-0">
                                <label class="form-label">Date avis non objection :</label>
                                <input type="date" class="form-control" v-model="alm.dateDaoAvisNonObjectionCtl">
                            </div>
                        </div>
                        <div class="col-md">
                            <div class="form-group m-0">
                                <label class="form-label">Date publication previsionnel :</label>
                                <input type="date" class="form-control" v-model="alm.dateDaoPrevPublication">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md">
                            <div class="form-group m-0">
                                <label class="form-label">Date reel publication :</label>
                                <input type="date" class="form-control" v-model="alm.dateDaoReelPublication">
                            </div>
                        </div>
                        <div class="col-md">
                            <div class="form-group m-0">
                                <label class="form-label">Date avis non objection :</label>
                                <input type="date" class="form-control" v-model="alm.dateDaoAvisNonObjectionPtf">
                            </div>
                        </div>
                        <div class="col-md">
                            <div class="form-group m-0">
                                <label class="form-label">Date reception dossier corrige :</label>
                                <input type="date" class="form-control" v-model="alm.dateDaoRecepDossCorigBal">
                            </div>
                        </div>
                        <div class="col-md">
                            <div class="form-group m-0">
                                <label class="form-label">Date autorise lancement :</label>
                                <input type="date" class="form-control" v-model="alm.dateDaoAutoriseLance">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md">
                            <div class="form-group m-0">
                                <label class="form-label">Date evaluation ouverture plis:</label>
                                <input type="date" class="form-control" v-model="alm.dateEvalOuvPlis">
                            </div>
                        </div>
                        <div class="col-md">
                            <div class="form-group m-0">
                                <label class="form-label">Date evaluation reception :</label>
                                <input type="date" class="form-control" v-model="alm.dateEvalRecepRptEval">
                            </div>
                        </div>
                        <div class="col-md">
                            <div class="form-group m-0">
                                <label class="form-label">Date evaluation reception avis non objection:</label>
                                <input type="date" class="form-control" v-model="alm.dateEvalRecepAvisNonObjectionCtl">
                            </div>
                        </div>
                        <div class="col-md">
                            <div class="form-group m-0">
                                <label class="form-label">Date reception avis PTF :</label>
                                <input type="date" class="form-control" v-model="alm.dateEvalRecepAvisNonObjectionPtf">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md">
                            <div class="form-group m-0">
                                <label class="form-label">Date examen juridique :</label>
                                <input type="date" class="form-control" v-model="alm.dateExamJuridirqueCtl">
                            </div>
                        </div>
                        <div class="col-md">
                            <div class="form-group m-0">
                                <label class="form-label">Date notification previsionnel :</label>
                                <input type="date" class="form-control" v-model="alm.datePrevNotifProv">
                            </div>
                        </div>
                        <div class="col-md">
                            <div class="form-group m-0">
                                <label class="form-label">Date reel notification :</label>
                                <input type="date" class="form-control" v-model="alm.dateReelNotifProv">
                            </div>
                        </div>
                        <div class="col-md">
                            <div class="form-group m-0">
                                <label class="form-label">Date previsionnel notification DEF :</label>
                                <input type="date" class="form-control" v-model="alm.datePrevNotifDef">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md">
                            <div class="form-group m-0">
                                <label class="form-label">Date reel notification DEF :</label>
                                <input type="date" class="form-control" v-model="alm.dateReelNotifDef">
                            </div>
                        </div>
                        <div class="col-md">
                            <div class="form-group m-0">
                                <label class="form-label">Date prevue ordonnancement :</label>
                                <input type="date" class="form-control" v-model="alm.datePrevueOrdSrv">
                            </div>
                        </div>
                        <div class="col-md">
                            <div class="form-group m-0">
                                <label class="form-label">Date approbation contrat :</label>
                                <input type="date" class="form-control" v-model="alm.dateApprobContrat">
                            </div>
                        </div>
                        <div class="col-md">
                            <div class="form-group m-0">
                                <label class="form-label">Chef Projet :</label>
                                <input type="text" class="form-control" v-model="alm.chefProjet">
                            </div>
                        </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          </div>
          
          <div class="modal-footer">
            <button class="btn btn-success" @click="genererMarche">Generer</button>
            <button class="btn btn-gray" data-bs-dismiss="modal">Fermer</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" v-if="task" id="detail-task" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-xl w-100" style="max-width: 80%;" role="document">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h6 class="modal-title fw-bold" style="font-size: 16px;">DETAIL ARBITRAGE LIGNE DE PTA</h6>
            <button aria-label="Close" class="btn-close text-white"
                    data-bs-dismiss="modal" type="button"><span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <ul class="row p-3">
              <li class="col-lg-12 mb-2">
                <div class="row">
                  <div class="col-md-2">
                    <div class="form-group">
                      <label class="form-label">Année <span class="text-danger">*</span></label>
                      <multi-select disabled deselect-label="Sélectionné" select-label=""
                                    :options="exercices" @select="loadActionsGrouped"
                                    placeholder="Sélectionné une année " label="annee"
                                    track-by="annee" :searchable="true"
                                    :custom-label="o => o.annee"
                                    v-model="payload.exercice">
                        <template slot="singleLabel" slot-scope="{ option }">
                          <strong> {{ option.annee }}</strong>
                        </template>
                        <span slot="noOptions">
                                                    <strong>Liste Vide</strong>
                                                </span>
                        <span slot="noResult">
                                                    <strong>Aucun Résultat</strong>
                                                </span>
                      </multi-select>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <label class="form-label">ID PTA Interne <span class="text-danger">*</span></label>
                      <input class="form-control "  v-model="task.idPtaAsin" readonly type="text">

                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="form-label">Activité</label>
                      <input class="form-control mb-4"  v-model="activite.description" readonly="" type="text">

                    </div>
                  </div>

                  <div class="col-md-2">
                    <div class="form-group">
                      <label class="form-label">Date Debut  <span class="text-danger">*</span></label>
                      <date-pick :language="fr" :bootstrapStyling="true" disabled minimumView="day" name="dateDebut"
                                 v-model="task.dateDebut" placeholder="Sélectionnez la date de debut"
                                 calendar-button-icon="fe fe-calendar" />

                    </div>
                  </div>

                  <div class="col-md-2">
                    <div class="form-group">
                      <label class="form-label">Date Fin  <span class="text-danger">*</span></label>
                      <date-pick :language="fr" :bootstrapStyling="true" disabled minimumView="day" name="dateDebut"
                                 v-model="task.dateFin" placeholder="Sélectionnez la date de Fin"
                                 calendar-button-icon="fe fe-calendar" />

                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group m-0 text-center">
                      <label class="form-label">REPORTS</label>
                      <hr class="mt-1" style="border-top: 2px solid #ccc;">
                      <br><br>
                      <div class="row  mb-1">
                       <div class="justify-content-center">
                         <div class="col-12">
                           <div class="d-flex flex-column align-items-center">
                             <label class="form-label">BN</label>
                             <AmountInput class="form-control border-dark w-50"  v-model="task.reportBnTtc"  />
                           </div>
                         </div>
                         <div class="col-12">
                           <div class="d-flex flex-column align-items-center">
                             <label class="form-label">PRET</label>
                             <AmountInput class="form-control border-dark w-50"  v-model="task.reportPretTtc"  />
                           </div>
                         </div>
                         <div class="col-12">
                           <div class="d-flex flex-column align-items-center">
                             <label class="form-label">DON</label>
                             <AmountInput class="form-control border-dark w-50"  v-model="task.reportDonTtc"  />
                           </div>
                         </div>
                         <div class="col-12">
                           <div class="d-flex flex-column align-items-center">
                             <label class="form-label">ANT</label>
                             <AmountInput class="form-control border-dark w-50"  v-model="task.reportAntTtc"  />
                           </div>
                         </div>
                         <div class="col-12">
                           <div class="d-flex flex-column align-items-center">
                             <label class="form-label">BA</label>
                             <AmountInput class="form-control border-dark w-50"  v-model="task.reportBaTtc"  />
                           </div>
                         </div>
                         <div class="col-12">
                           <div class="d-flex flex-column align-items-center">
                             <label class="form-label">TOTAL Report :</label>

                             <AmountInput class="form-control border-dark w-50" readonly :value="reportMobiliseTot"  />
                           </div>
                         </div>
                       </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group m-0">
                      <label class="form-label">BESOINS</label>
                      <hr class="mt-1" style="border-top: 2px solid #ccc;">

                      <div class="row ">
                        <div class="col-md-12">
                          <div class="row ">
                            <div class="col-6">
                              <label class="form-label">Autorisation d'engagement</label>
                              <hr class="mt-1" style="border-top: 2px solid #ccc;">
                              <div class="col-12">
                                <label class="form-label">BN</label>
                                <AmountInput class="form-control border-dark"  v-model="task.besoinAeBnTtc"  />
                              </div>
                              <div class="col-12">
                                <label class="form-label">PRET</label>
                                <AmountInput class="form-control border-dark"  v-model="task.besoinAePretTtc"  />
                              </div>
                              <div class="col-12">
                                <label class="form-label">DON</label>
                                <AmountInput class="form-control border-dark"  v-model="task.besoinAeDonTtc"  />
                              </div>
                              <div class="col-12">
                                <label class="form-label">ANT</label>
                                <AmountInput class="form-control border-dark"  v-model="task.besoinAeAntTtc"  />
                              </div>

                              <div class="col-12">
                                <label class="form-label">BA</label>
                                <AmountInput class="form-control border-dark"  v-model="task.besoinAeBaTtc"  />
                              </div>
                              <div class="col-12">
                                <label class="form-label">TOTAL AE</label>
                                <AmountInput class="form-control border-dark" readonly :value="besoinAeTotTtc"  />
                              </div>

                            </div>
                            <div class="col-6">
                              <label class="form-label">Crédit de paiement</label>
                              <hr class="mt-1" style="border-top: 2px solid #ccc;">
                              <div class="col-12">
                                <label class="form-label">BN</label>
                                <AmountInput class="form-control border-dark"  v-model="task.besoinCpBnTtc"  />
                              </div>
                              <div class="col-12">
                                <label class="form-label">PRET</label>
                                <AmountInput class="form-control border-dark"  v-model="task.besoinCpPretTtc"  />
                              </div>
                              <div class="col-12">
                                <label class="form-label">DON</label>
                                <AmountInput class="form-control border-dark "  v-model="task.besoinCpDonTtc"  />
                              </div>
                              <div class="col-12">
                                <label class="form-label">ANT</label>
                                <AmountInput class="form-control border-dark "  v-model="task.besoinCpAntTtc"  />
                              </div>

                              <div class="col-12">
                                <label class="form-label">BA</label>
                                <AmountInput class="form-control border-dark "  v-model="task.besoinCpBaTtc"  />
                              </div>
                              <div class="col-12">
                                <label class="form-label">TOTAL CP</label>
                                <AmountInput class="form-control border-dark " readonly :value="besoinCpTotTtc"  />
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group m-0">
                      <label class="form-label">ALLOUES</label>
                      <hr class="mt-1" style="border-top: 2px solid #ccc;">
                      <div class="row ">
                        <div class="col-md-12">
                          <div class="row ">
                            <div class="col-6">
                              <label class="form-label">Autorisation d'engagement</label>
                              <hr class="mt-1" style="border-top: 2px solid #ccc;">
                              <div class="col-12">
                                <label class="form-label">BN</label>
                                <AmountInput class="form-control border-dark "  v-model="task.alloueAeBnTtc"  />
                              </div>
                              <div class="col-12">
                                <label class="form-label">PRET</label>
                                <AmountInput class="form-control border-dark "  v-model="task.alloueAePretTtc"  />
                              </div>
                              <div class="col-12">
                                <label class="form-label">DON</label>
                                <AmountInput class="form-control border-dark "  v-model="task.alloueAeDonTtc"  />
                              </div>
                              <div class="col-12">
                                <label class="form-label">ANT</label>
                                <AmountInput class="form-control border-dark "  v-model="task.alloueAeAnTtc"  />
                              </div>

                              <div class="col-12">
                                <label class="form-label">BA</label>
                                <AmountInput class="form-control border-dark "  v-model="task.alloueAeBaTtc"  />
                              </div>
                              <div class="col-12">
                                <label class="form-label">TOTAL AE</label>
                                <AmountInput class="form-control border-dark " readonly :value="alloueAeTotTtc"  />
                              </div>

                            </div>
                            <div class="col-6">
                              <label class="form-label">Crédit de paiement</label>
                              <hr class="mt-1" style="border-top: 2px solid #ccc;">
                              <div class="col-12">
                                <label class="form-label">BN</label>
                                <AmountInput class="form-control border-dark "  v-model="task.alloueCpBnTtc"  />
                              </div>
                              <div class="col-12">
                                <label class="form-label">PRET</label>
                                <AmountInput class="form-control border-dark "  v-model="task.alloueCpPretTtc"  />
                              </div>
                              <div class="col-12">
                                <label class="form-label">DON</label>
                                <AmountInput class="form-control border-dark "  v-model="task.alloueCpBnTtc"  />
                              </div>
                              <div class="col-12">
                                <label class="form-label">ANT</label>
                                <AmountInput class="form-control border-dark "  v-model="task.alloueCpAnTtc"  />
                              </div>

                              <div class="col-12">
                                <label class="form-label">BA</label>
                                <AmountInput class="form-control border-dark "  v-model="task.alloueCpBaTtc"  />
                              </div>
                              <div class="col-12">
                                <label class="form-label">TOTAL CP</label>
                                <AmountInput class="form-control border-dark " readonly :model-value="alloueCpTotTtc"   />
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr class="mt-2" style="border-top: 2px solid #ccc;">
                  <div class="col-md-12">
                    <div class="form-group m-0">
                      <div class="row ">
                        <div class="col-4">
                          <div class="form-group">
                            <div class="form-floating floating-label1">
                              <textarea class="form-control" v-model="task.commentaire" placeholder="Comments" id="floatingTextarea2" style="height: 100px"></textarea>
                              <label for="floatingTextarea2">Comments</label>
                            </div>
                          </div>
                        </div>
                        <div class="col-4">
                          <label class="form-label">Statut Arbitrage <span class="text-danger">*</span></label>
                          <multi-select  deselect-label="Sélectionné" select-label=""
                                         :options="statutArbitrages"
                                         placeholder="Sélectionné le Statut " label="statut"
                                         track-by="idStatutArb" :searchable="true"
                                         :custom-label="o => o.libStatutArb"
                                         v-model="obStatutArbitrage">
                            <template slot="singleLabel" slot-scope="{ option }">
                              <strong> {{ option.libStatutArb }}</strong>
                            </template>
                            <span slot="noOptions">
                                                    <strong>Liste Vide</strong>
                                                </span>
                            <span slot="noResult">
                                                    <strong>Aucun Résultat</strong>
                                                </span>
                          </multi-select>
                        </div>

                        <div class="col-4 d-flex align-items-center">
                          <button class="btn btn-primary ms-auto" @click="saved(task)" >Enregistrer Arbitrage</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr class="mt-2" style="border-top: 2px solid #ccc;">
                </div>
              </li>

              <li class="col-lg-12 mb-2">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="card">
                      <div class="card-header">
                        <h3 class="card-title justify-content-center">Historique de l'Arbitrage</h3>
                      </div>
                      <div class="card-body">
                        <div class="table-responsive">
                          <table class="table table-hover table-bordered">
                            <thead class="border-top success02">
                            <tr >
                              <th class="fw-bold">ID</th>
                              <th class="fw-bold">Statut Arbitrage </th>
                              <th class="fw-bold">Report </th>
                              <th class="fw-bold">Besoins AE</th>
                              <th class="fw-bold">Besoins CP</th>
                              <th class="fw-bold">Allocations AE</th>
                              <th class="fw-bold">Allocations CP</th>
                              <th class="fw-bold">Commentaire</th>
                              <th class="fw-bold">Date Arbitrage </th>
                              <th class="fw-bold">Auteur </th>
                            </tr>
                            </thead>
                            <tbody v-if="lastRecordArbitrage.length > 0">
                            <tr v-for="(arbitrage, index) in lastRecordArbitrage" :key="index" class="border-bottom">
                              <td>{{arbitrage.id}}</td>
                              <td>{{arbitrage.idStatutArb?.idStatutArb}} - {{arbitrage.idStatutArb?.libStatutArb}}</td>
                              <td class="text-end">{{arbitrage.report.toLocaleString('fr-FR')}}</td>
                              <td class="text-end">{{arbitrage.besoinAe.toLocaleString('fr-FR')}}</td>
                              <td class="text-end">{{arbitrage.besoinCp.toLocaleString('fr-FR')}}</td>
                              <td class="text-end">{{arbitrage.allocationAe.toLocaleString('fr-FR')}}</td>
                              <td class="text-end">{{arbitrage.allocationCp.toLocaleString('fr-FR')}}</td>
                              <td>{{arbitrage.commentaire}}</td>
                              <td>{{formatDate(arbitrage.dateMaj,'long')}}</td>
                              <td>{{arbitrage.auteur}}</td>

                            </tr>
                            </tbody>
                            <tbody v-else>
                            <tr class="primary02">
                              <td colspan="10" class="text-center">Aucune Historique trouvée</td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="modal-footer">
            <button class="btn btn-gray" data-bs-dismiss="modal">Fermer</button>
          </div>
        </div>
      </div>
    </div>


    <div class="row">
      <div class="col-12 col-sm-12" v-if="showList">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-label">Année <span class="text-danger">*</span></label>
                  <multi-select deselect-label="Sélectionné" select-label=""
                                :options="exercices" @select="getAllMarche"
                                placeholder="Sélectionné une année " label="annee"
                                track-by="annee" :searchable="true"
                                :custom-label="o => o.annee"
                                v-model="payload.exercice">
                    <template slot="singleLabel" slot-scope="{ option }">
                      <strong> {{ option.annee }}</strong>
                    </template>
                    <span slot="noOptions">
                                                <strong>Liste Vide</strong>
                                            </span>
                    <span slot="noResult">
                                                <strong>Aucun Résultat</strong>
                                            </span>
                  </multi-select>

                </div>
              </div>
              <div class="col-md-6 mt-6">
                <div class="d-flex">
                  <button class="btn btn-info text-start m-2" @click="generateFollowUpFile" :disabled="!payload.exercice?.annee">
                    <span class="fe fe-check"></span>
                    Generer fichier de suivi
                  </button>
                  <button class="btn btn-info text-start m-2" @click="validatePPM" :disabled="!payload.exercice?.annee">
                    <span class="fe fe-check"></span>
                    Valider PPM
                  </button>
                  <button class="btn btn-info text-start m-2" @click="exportPPMToExcel" :disabled="!payload.exercice?.annee">
                    <span class="fe fe-check"></span>
                    Exporter PPM vers Excel
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md">
                <label class="form-label">Date Debut</label>
                <input type="date" class="form-control border-dark"  v-model="ppm.dateDebut"  />
              </div>
              <div class="col-md">
                <label class="form-label">Date Fin</label>
                <input type="date" class="form-control border-dark"  v-model="ppm.dateFin"  />
              </div>
              <div class="col-md">
                <label class="form-label">Date Creation</label>
                <input type="date" class="form-control border-dark"  v-model="ppm.createdAt"  />
              </div>
            </div>
          </div>
        </div>

        

        <div class="card" v-if="marches.length > 0">
          <div class="card-header">
            <h4>PTA de {{ payload.exercice.annee }}</h4>
          </div>
          <div class="card-body">
            <div class="tab-content" id="nav-tabContent">
              <div class="tab-pane fade show active" id="home-tab-pane" role="tabpanel" aria-labelledby="nav-home-tab" tabindex="0">
                
              </div>
              <div>
              <div class="my-2">
                <button class="btn btn-info text-start" @click="toggleAll">
                  <span :class="allExpanded ? 'fe fe-minus' : 'fe fe-plus'"></span>
                  {{ allExpanded ? 'Replier' : 'Déplier' }}
                </button>
                <p class="text-end">(En miliers FCFA TTC)</p>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="table-responsive">
                    <table class="table table-hover table-bordered text-nowrap mb-0">
                      <thead class="border-top success02">
                      <tr>
                        <th><input type="checkbox" v-model="selectAll" class="checkbox" @change="toggleSelectAll1" :id="`optionOne`" /></th>
                        <th>Action</th>
                        <th>Reference</th>
                        <th>Description</th>
                        <th>Type de marche</th>
                        <th>Mode de passation</th>
                        <th>Montant Estimatif</th>
                        <th>Source de financement</th>
                        <th>Ligne d'imputation budgetaire</th>
                        <th>Organe de controle</th>
                        <th>Autorisation</th>
                        <th>Date de reception</th>
                      </tr>
                      </thead>

                      <tbody>
                        <tr v-for="(action, aIndex) in marches" :key="'a-' + aIndex">
                          <td class="text-center">
                            <input type="checkbox" :value="action.id" v-model="selectedItems" class="checkbox" @change="updateSelectAll1" :id="`dc-tache-${tIndex}`" />
                          </td>
                          <td></td>
                          <td>{{ action.refPpm }}</td>
                          <td>{{ action.intitule }}</td>
                          <td>{{ action.idTypeMarche }}</td>
                          <td>{{ action.idFortStatRet }}</td>
                          <td>{{ action.montantContratHt }}</td>
                          <td>{{ action.sourceFinancement.sourceFinancement }}</td>
                          <td>{{ action.ligneImputation }}</td>
                          <td>{{ action.organeControle }}</td>
                          <td>{{ action.autorisationEngag }}</td>
                          <td>{{ action.dateRecepTdrs ? formatDate(action.dateRecepTdrs) : '' }}</td>
                        </tr>
                      </tbody>
                    </table>

                  </div>
                </div>
              </div>
              <div class="row">
                <div class="d-flex justify-content-end">
                  <button class="btn btn-info text-start p-2 col-md-3" @click.prevent="generateAll">
                    <span class="fe fe-export"></span>
                    Generer PPM
                  </button>
                </div>
              </div>
            </div>
            </div>

          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
//import $ from 'jquery';
import {mapGetters, mapActions} from 'vuex';
import * as lang from "vuejs-datepicker/src/locale";
import AmountInput from "../../components/AmountInput.vue";

export default {
  name: "ArbitragePta",
  components: {AmountInput},
  data() {
    return {
      lang: lang,
      marche: {},
      marcheData: {},
      ptaData: {},
      allMarches: [],
      payload: {currentStep: 1, classeur: null, composante: ""},
      pta: {
        annee: "",
        dateDebut: "",
        dateFin: "",
        description: "",
        besoinAeBnTtc: 0,
        besoinAePretTtc: 0,
        besoinAeDonTtc: 0,
        besoinAeAntTtc: 0,
        besoinAeBaTtc: 0,
        besoinAeTotTtc: 0,
        besoin_cp_bn_ttc: 0,
        besoinCpPretTtc: 0,
        besoinCpDonTtc: 0,
        besoinCpAntTtc: 0,
        besoinCpBaTtc: 0,
        besoinCpTotTtc: 0
      },
      marches: [],
      ppm: {},
      save: true,
      showList: true,
      notModified: false,
      choixCompo: false,
      choixAnnee: false,
      classeurs: [],
      composantes: [],
      exercices: [],
      obStatutArbitrage: {
        idStatutArb: "0.0",
        libStatutArb: "A faire"
      },
      statutArbitrages: [],
      typologies: [],
      methodologies: [],
      sourcesFinancement: [],
      lesactivites: [],
      lestaches: [],
      ptas: [],
      activite: null,
      task: null,
      allActionsGrouped: [],
      allActionsGroupedPrev: [],
      allDatas: [],
      selectedItems: [],
      selectedItems2: [],
      selectAll: false,
      selectAll2: false,
      collapsedRows: {},
      lastRecordArbitrage: [],
      allExpanded: false,
    }
  },
  computed: {
    ...mapGetters({items: 'generationPta'}),
    filtersItems() {
      return this.items || [];
    },
    fr() {
      return this.lang.fr;
    },
    besoinAeTotTtc() {
      const t = this.task;
      return (Number(t.besoinAeBnTtc) || 0)
          + (Number(t.besoinAeAntTtc) || 0)
          + (Number(t.besoinAePretTtc) || 0)
          + (Number(t.besoinAeBaTtc) || 0)
          + (Number(t.besoinAeDonTtc) || 0);
    },

    besoinCpTotTtc() {
      const t = this.task;
      return (Number(t.besoinCpBnTtc) || 0)
          + (Number(t.besoinCpAntTtc) || 0)
          + (Number(t.besoinCpPretTtc) || 0)
          + (Number(t.besoinCpBaTtc) || 0)
          + (Number(t.besoinCpDonTtc) || 0);
    },

    alloueAeTotTtc() {
      const t = this.task;
      return (Number(t.alloueAeBnTtc) || 0)
          + (Number(t.alloueAeAnTtc) || 0)
          + (Number(t.alloueAePretTtc) || 0)
          + (Number(t.alloueAeBaTtc) || 0)
          + (Number(t.alloueAeDonTtc) || 0);
    },

    alloueCpTotTtc() {
      const t = this.task;
      return (Number(t.alloueCpBnTtc) || 0)
          + (Number(t.alloueCpAnTtc) || 0)
          + (Number(t.alloueCpPretTtc) || 0)
          + (Number(t.alloueCpBaTtc) || 0)
          + (Number(t.alloueCpDonTtc) || 0);
    },
    reportMobiliseTot() {
      const t = this.task;
      const bn = Number(t.reportBnTtc) || 0;
      const pret = Number(t.reportPretTtc) || 0;
      const ant = Number(t.reportAntTtc) || 0;
      const ba = Number(t.reportBaTtc) || 0;
      const don = Number(t.reportDonTtc) || 0;

      console.log('Recomputing total:', t.reportBnTtc, t.reportPretTtc);

      return bn + pret + ant + ba + don;
    },
    totalBesoinAETotal() {
      return this.lestaches.reduce((acc, tache) => {
        return acc + this.totalBesoinAE(tache);
      }, 0);
    },
    totalBesoinCPTotal() {
      return this.lestaches.reduce((acc, tache) => {
        return acc + this.totalBesoinCP(tache);
      }, 0);
    },
    totalAlloueAETotal() {
      return this.lestaches.reduce((acc, tache) => {
        return acc + this.totalAlloueAE(tache);
      }, 0);
    },
    totalAlloueCPTotal() {
      return this.lestaches.reduce((acc, tache) => {
        return acc + this.totalAlloueCP(tache);
      }, 0);
    },
    reportTotal() {
      return this.lestaches.reduce((acc, tache) => {
        return acc + this.totalReport(tache);
      }, 0);
    }
  },
  watch: {
    imported: {
      immediate: true,
      handler(val) {
        if (val) this.payload.currentStep++;
      },
    },
  },
  mounted() {
  },
  methods: {
    ...mapActions('generationPta', ['all', 'add']),
    async reloadModalData(task) {
      this.$loading(true);
      const { data } = await this.$http.get(`/pta/parent/all/${task.idDetailParent}`);
      this.lestaches = data;

      const { data: activ } = await this.$http.get(`/pta/${task.idActivite}`);
      this.activite = activ;

      this.loadActionsGrouped();


    },
    verifierDatesPpm(ppm) {
      return !!(ppm.dateDebut && ppm.dateFin && ppm.createdAt);
    },
    generateFollowUpFile(){
      if (!this.verifierDatesPpm(this.ppm)) {
        swal('Information!', 'Veuillez renseigner toutes les dates du PPM.', 'warning');
      }else{
        this.$loading(true);
        this.$http.post('/planPassation/generate/ppm/'+this.payload.exercice.annee, this.ppm)
          .then(({ data }) => {
            if(data.status){
              swal('Information!', data.message || 'Fichier de suivi généré avec succès.', 'success');
            }else{
              swal('Information!', data.message || 'Aucune action sélectionnée pour la génération du fichier de suivi.', 'warning');
            }
          })
          .catch((error) => {
            swal('Information!', 'Une erreur est survenue lors de la génération. ' + error, 'warning');
          })
          .finally(() => this.$loading(false));
      }
    },
    exportPPMToExcel() {

        const csvRows = [];

        const headers = this.marches.map(col => col.label);

        csvRows.push(headers.join(","));

        this.marches.forEach(row => {

          const values = this.marches.map(col => '"' + (row[col.key] ?? '') + '"');

          csvRows.push(values.join(","));

        });

        const blob = new Blob([csvRows.join("\n")], { type: 'text/csv' });

        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');

        link.href = url;

        link.download = 'data.csv';

        link.click();

        URL.revokeObjectURL(url);

      },
    getAllMarche(){
      this.$loading(true);
      this.$http.get('/planPassation/marche/ppm/'+this.payload.exercice.annee)
        .then(({ data }) => {
          this.marches = data || [];
        })
        .catch((error) => {
          swal('Information!', 'Une erreur est survenue lors de la recuperation des marches. ' + error, 'warning');
        })
        .finally(() => this.$loading(false));
    },
    validatePPM(){
      this.$loading(true);
      this.$http.post('/pta/validate-ppm', { actions: this.selectedItems })
        .then(({ data }) => {
          swal('Information!', 'PPM validé avec succès.', 'success');
        })
        .catch((error) => {
          swal('Information!', 'Une erreur est survenue lors de la validation. ' + error, 'warning');
        })
        .finally(() => this.$loading(false));
    },
    /*exportPPMToExcel(){
      this.$loading(true);
      this.$http.post('/pta/export-ppm', { actions: this.selectedItems })
        .then(({ data }) => {
          swal('Information!', 'PPM exporté vers Excel avec succès.', 'success');
        })
        .catch((error) => {
          swal('Information!', 'Une erreur est survenue lors de l\'exportation. ' + error, 'warning');
        })
        .finally(() => this.$loading(false));
    },*/
    toggleSelectAll1() {
      if (this.selectAll) {
        this.selectedItems = this.allActionsGrouped.map(item => item.id);
      } else {
        this.selectedItems = [];
      }
    },
    updateSelectAll1() {
      this.selectAll = this.selectedItems.length === this.allActionsGrouped.length;
    },
    toggleSelectAll2() {
      if (this.selectAll2) {
        this.selectedItems2 = this.allActionsGroupedPrev.map(item => item.id);
      } else {
        this.selectedItems2 = [];
      }
    },
    updateSelectAll2() {
      this.selectAll2 = this.selectedItems2.length === this.allActionsGroupedPrev.length;
    },
    toggleCollapse(type, index) {
      const key = `${type}-${index}`;
      this.$set(this.collapsedRows, key, !this.collapsedRows[key]);
    },
    isCollapsed(type, index) {
      const key = `${type}-${index}`;
      return this.collapsedRows[key];
    },
    toggleAll() {
      this.allExpanded = !this.allExpanded;

      this.allActionsGrouped.forEach((action, aIndex) => {
        const actionKey = `action-${aIndex}`;
        this.$set(this.collapsedRows, actionKey, this.allExpanded);

        action.projetPags.forEach((projet, pIndex) => {
          const projetKey = `projet-${aIndex + '-' + pIndex}`;
          this.$set(this.collapsedRows, projetKey, this.allExpanded);

          projet.detailsComposantes.forEach((activite, actIndex) => {
            const activiteKey = `activite-${aIndex + '-' + pIndex + '-' + actIndex}`;
            this.$set(this.collapsedRows, activiteKey, this.allExpanded);
          });

        });


      });
    },
    genererMarche(){
        
        this.$loading(true);
        this.$http.put('/pta/declarer/marche/'+this.activite.id, this.activite)
        .then(async ({data}) => {
            swal('Information!', 'PPM genere avec succès.', 'success');
            $('#ppm-start').modal('hide');
        })
        .catch((error) => {
            swal('Information!', 'Une erreur est survenue lors de la generation. ' + error, 'warning');
        })
        .finally(() => this.$loading(false));
    },
    saveMarche(){
        this.$loading(true);
        this.$http.put('/pta/declarer/marche/'+this.activite.id, this.activite)
        .then(async ({data}) => {
            swal('Information!', 'Marche declare avec succès.', 'success');
            $('#modal-detail-activity').modal('hide');
        })
        .catch((error) => {
            swal('Information!', 'Une erreur est survenue lors de la generation. ' + error, 'warning');
        })
        .finally(() => this.$loading(false));
    },
    async displayActivity(item) {
      this.$loading(true);
      try {
        await this.getPta(item.id);
        $('#modal-detail-activity').modal('show');
      } catch (error) {
        console.error('Erreur dans displayActivity:', error);
      } finally {
        this.$loading(false);
      }
    },
    async generateOne(item) {
      this.$loading(true);
      try {
        this.allMarches = [];
        this.ptaData = item;
        this.allMarches.push({
          intitule: this.ptaData.description,
          tempActivite: this.ptaData,
          montantPpmHt: ( this.ptaData.alloueAeTotTtc * 1000 ) / 1.18,
        })
        $('#ppm-start').modal('show');
      } catch (error) {
        console.error('Erreur dans generateOne:', error);
      } finally {
        this.$loading(false);
      }
    },
    async generateAll() {
      this.$loading(true);
      try {
        this.allMarches = [];
        this.selectedItems.forEach(item => {
          // Traitement sur chaque item
          let dataFound = this.findByIdInTable(item, this.allActionsGrouped);
          if (dataFound) {
            this.allMarches.push({
              intitule: dataFound.description,
              tempActivite: dataFound,
              montantPpmHt: (dataFound.alloueAeTotTtc * 1000) / 1.18,
            });
          }
        });
        $('#ppm-start').modal('show');
      } catch (error) {
        console.error('Erreur dans generateOne:', error);
      } finally {
        this.$loading(false);
      }
    },
    findByIdInTable(id, data) {
      for (const dataFound of data) {
        for (const projet of dataFound.projetPags) {
          //if (projet.id === id) return projet;
          if (Array.isArray(projet.detailsComposantes)) {
            for (const composante of projet.detailsComposantes) {
              if (composante.activite.id === id) return composante;
              if (composante.activite && Array.isArray(composante.activite.taches)) {
                const tache = composante.activite.taches.find(t => t.id === id);
                if (tache) return tache;
              }
            }
          }
        }
      }
      return null;
    },
    async editTask(item, active) {
      this.$loading(true);

      try {
        this.activite = active;
        await this.getOnePta(item.id,"tache");

        await this.loadHistoryArbitrage(item);

        $('#detail-task').modal('show');
      } catch (error) {
        console.error('Erreur dans edit task:', error);
      } finally {
        this.$loading(false);
      }
    },
    totalBesoinAE(item) {
      return (
          item.besoinAeAntTtc +
          item.besoinAeBaTtc +
          item.besoinAeBnTtc +
          item.besoinAeDonTtc +
          item.besoinAePretTtc
      )
    },
    totalBesoinCP(item) {
      return (
          item.besoinCpAntTtc +
          item.besoinCpBaTtc +
          item.besoinCpBnTtc +
          item.besoinCpDonTtc +
          item.besoinCpPretTtc
      )
    },
    totalAlloueCP(item) {
      return (
          item.alloueCpAnTtc +
          item.alloueCpBaTtc +
          item.alloueCpBnTtc +
          item.alloueCpDonTtc +
          item.alloueCpPretTtc
      )
    },
    totalAlloueAE(item) {
      return (
          item.alloueAeAnTtc +
          item.alloueAeBaTtc +
          item.alloueAeBnTtc +
          item.alloueAeDonTtc +
          item.alloueAePretTtc
      )
    },
    totalReport(item) {
      return (
          Number(item.reportAntTtc)
          + Number(item.reportBaTtc)
          + Number(item.reportBnTtc)
          + Number(item.reportDonTtc)
          + Number(item.reportPretTtc)
      )
    },
    isEmpty(value) {
      return value === null || value === '' || (typeof value === 'object' && Object.keys(value).length === 0);
    },
    onSearch(offset) {
      this.$loading(true);
      if (offset > 0) this.option.page = offset - 1;
      this.$router.push({query: this.option}).catch(() => {
      });
      this.getExercices();
      this.getClasseurs();
      this.getStatutArbitrage();
    },
    isValidMontants() {
      const totalAlloueAe = this.alloueAeTotTtc;
      const totalAlloueCp = this.alloueCpTotTtc;
      const totalBesoinCp = this.besoinCpTotTtc;
      const totalBesoinAe = this.besoinAeTotTtc;

      const allPositive = totalAlloueAe >= 0 && totalAlloueCp >= 0 &&  totalBesoinAe >= 0 &&  totalBesoinCp >= 0;

      return allPositive > 0;
    },
    loadHistoryArbitrage(task) {
      return this.$http.get(`/arbitragePta/pta/${task.id}`)
          .then(({ data }) => {
            console.log("darrrrr", data);
            this.lastRecordArbitrage = data;
          })
          .catch(err => {
            console.error("Erreur getDetailComposant:", err);
            throw err;
          });
    },

    getAllPtaByDetailComposant(id) {
      return this.$http.get(`/pta/parent/all/${id}`)
          .then(({ data }) => {
            this.lestaches = data;
          })
          .catch(err => {
            console.error("Erreur getAllPtaByDetailComposant:", err);
            throw err;
          });
    },
    getPta(id) {
      return this.$http.get(`/pta/${id}`)
          .then(({ data }) => {
              this.activite = data;
          })
          .catch(err => {
            console.error("Erreur getPta:", err);
            throw err;
          });
    },
    getOnePta(id,type) {
      return this.$http.get(`/pta/${id}`)
          .then(({ data }) => {
            if(type ==="tache"){
              this.task = data;
            }else {
              this.activite = data;
            }
          })
          .catch(err => {
            console.error("Erreur getPta:", err);
            throw err;
          });
    },
    saved(task) {
      this.$loading(true);
      if (!this.isValidMontants()) {
        swal('Information!',"Tous les montants doivent être positifs");
        this.$loading(false);
        return;
      }
      if(task.commentaire ==='' || task.commentaire ==null){
        swal('Information!',"Veillez entrer un commentaire");
        this.$loading(false);
        return;
      }
      if(this.obStatutArbitrage ==='' || this.obStatutArbitrage ==null || this.obStatutArbitrage.idStatutArb === "0.0"){
        swal('Information!',"Veillez selectionner le statut");
        this.$loading(false);
        return;
      }
      if(this.save) {
        task.besoinAe = this.besoinAeTotTtc
        task.besoinCp = this.besoinCpTotTtc
        task.allocationAe = this.alloueAeTotTtc
        task.allocationCp = this.alloueCpTotTtc
        task.report = this.reportMobiliseTot
        task.idPta = task.idPta || {};
        task.idPta.id = task.id;
        task.idStatutArb = this.obStatutArbitrage;
        task.idActivite = this.activite.id;
        this.task = task;
        this.$loading(true);
        this.$http.post('/arbitragePta/with-request', task)
            .then(async ({data}) => {
              await this.loadHistoryArbitrage(task);

              await this.reloadModalData(task);

              task.commentaire = ""
              this.obStatutArbitrage =  {
                idStatutArb: "0.0",
                libStatutArb: "A faire"
              }

              this.$loading(false)
              swal('Information!', 'Sauvegarde  effectué avec succès.', 'success');

            })
            .catch((error) => {
              swal('Information!', 'Une erreur est survenue lors de la sauvegarde. ' + error, 'warning');
            })
            .finally(() => this.$loading(false));
      }


    },
    cadrage() {
      console.log(this.ptas);
    },
    getClasseurs() {
      this.$http.get('/classeurs/all')
          .then(({data}) => {
            console.log(data);
            console.log(1);
            this.classeurs = data;
            this.$loading(false);
          });


    },

    getExercices() {
      this.$http.get('/exercice')
          .then(({data}) => {
            console.log(data);
            console.log(1);
            this.exercices = data;

          });
    },
    getStatutArbitrage() {
      this.$http.get('/statutArbitrage')
          .then(({data}) => {
            console.log(data);
            console.log(1);
            this.statutArbitrages = data;

          });
    },

    loadActionsGrouped() {
      this.$loading(true);
      this.$http.get(`/search/actions/${this.payload.exercice.annee}`)
          .then(async ({data}) => {
            this.choixAnnee = true;
            this.allActionsGrouped = data;
            this.allDatas = data;
            this.$loading(false);
          });
    },
    loadAnneePassee() {
      this.$loading(true);
      this.$http.get(`/search/actions/${this.payload.exercice.annee - 1}`)
          .then(async ({data}) => {
            this.allActionsGroupedPrev = data;
            this.$loading(false);
          });
    },
    formatDate(dateStr, mode = 'court') {
      const date = new Date(dateStr);

      const optionsLong = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      };

      const optionsCourt = {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit'
      };

      const options = mode === 'long' ? optionsLong : optionsCourt;

      return date.toLocaleString('fr-FR', options);
    },
    getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1) + min);
    }

  },
  created() {

    this.onSearch()
    this.getExercices()
    this.getStatutArbitrage()
    this.$http.get('/typologiePta')
    .then(({data}) => {
        this.typologies = data;
    });

    this.$http.get('/methodologieMarche')
    .then(({data}) => {
        this.methodologies = data;
    });

    this.$http.get('/sourceFinancement')
    .then(({data}) => {
        this.sourcesFinancement = data;
    });


  },
}
</script>

<style>

.loading-screen {
  z-index: 9999999999999 !important;
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

</style>